<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_19213_13992)">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12 11.7748V4.01562C7.81464 4.27372 4.5 7.7499 4.5 12.0003C4.5 12.8156 4.62199 13.6026 4.84871 14.3437L12 11.7748ZM13 11.7477V4.01562C17.1854 4.27372 20.5 7.7499 20.5 12.0003C20.5 13.5991 20.031 15.0883 19.223 16.338L13 11.7477ZM12.533 12.6459L5.20092 15.2798C6.45324 18.0627 9.25034 20.0003 12.5 20.0003C14.9604 20.0003 17.1613 18.8896 18.6288 17.1423L12.533 12.6459Z"
				:fill="props.iconColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_19213_13992">
				<rect width="16" height="16" :fill="props.iconColor" transform="translate(4.5 4)" />
			</clipPath>
		</defs>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
